import moment from "moment";
import { BaseEntity } from "./BaseEntity";

export interface Organization extends BaseEntity {
    name: string;
    description?: string;
}

export function OrganizationFromJSON(json: any): Organization {
    if((json === undefined) || (json === null)) {
        return json;
    }

    return {
        'id': json['id'],
        'name': json['name'],
        'description': json['description']
    }
}

export function OrganizationToJSON(value?: Organization | null): any {
    if(value === undefined) {
        return undefined;
    }
    if(value === null) {
        return null;
    }
    return {
        'id': value.id,
        'created': value.created ? moment(value.created).format('yyyy-MM-DDTHH:mm:ssZZ') : '',
        'name': value.name,
        'description': value.description
    }
}